import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BlameSource = /*#__PURE__*/function (BlameSource) {
  BlameSource[BlameSource["BLAME_SOURCE_SYSTEM"] = 0] = "BLAME_SOURCE_SYSTEM";
  BlameSource[BlameSource["BLAME_SOURCE_USER"] = 1] = "BLAME_SOURCE_USER";
  return BlameSource;
}(BlameSource || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ValidationErrorCodes = /*#__PURE__*/function (ValidationErrorCodes) {
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_UNKNOWN"] = 0] = "VALIDATION_ERROR_CODES_UNKNOWN";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_APP_NOT_FOUND"] = 1] = "VALIDATION_ERROR_CODES_APP_NOT_FOUND";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_NO_ORDER_FORM_SUBMISSION_ID"] = 2] = "VALIDATION_ERROR_CODES_NO_ORDER_FORM_SUBMISSION_ID";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ORDER_FORM_NOT_FOUND"] = 3] = "VALIDATION_ERROR_CODES_ORDER_FORM_NOT_FOUND";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ORDER_FORM_ALREADY_USED"] = 4] = "VALIDATION_ERROR_CODES_ORDER_FORM_ALREADY_USED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ORDER_FORM_NOT_SUPPORTED"] = 5] = "VALIDATION_ERROR_CODES_ORDER_FORM_NOT_SUPPORTED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_INVALID_ENTRY_URL"] = 6] = "VALIDATION_ERROR_CODES_INVALID_ENTRY_URL";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ENTRY_URL_NOT_PROVIDED"] = 7] = "VALIDATION_ERROR_CODES_ENTRY_URL_NOT_PROVIDED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_INVALID_DEPENDENCY"] = 8] = "VALIDATION_ERROR_CODES_INVALID_DEPENDENCY";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ALREADY_ACTIVE"] = 9] = "VALIDATION_ERROR_CODES_ALREADY_ACTIVE";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_EDITION_NOT_PROVIDED"] = 10] = "VALIDATION_ERROR_CODES_EDITION_NOT_PROVIDED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_EDITIONS_NOT_SUPPORTED"] = 11] = "VALIDATION_ERROR_CODES_EDITIONS_NOT_SUPPORTED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_INVALID_EDITION"] = 12] = "VALIDATION_ERROR_CODES_INVALID_EDITION";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_TRIAL_NOT_SUPPORTED"] = 13] = "VALIDATION_ERROR_CODES_TRIAL_NOT_SUPPORTED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_ACCOUNT_GROUP_NOT_FOUND"] = 14] = "VALIDATION_ERROR_CODES_ACCOUNT_GROUP_NOT_FOUND";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_NO_COUNTRY_INFORMATION"] = 15] = "VALIDATION_ERROR_CODES_NO_COUNTRY_INFORMATION";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_UNSUPPORTED_COUNTRY"] = 16] = "VALIDATION_ERROR_CODES_UNSUPPORTED_COUNTRY";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_CANNOT_CHANGE_EDITION_OF_TRIAL"] = 17] = "VALIDATION_ERROR_CODES_CANNOT_CHANGE_EDITION_OF_TRIAL";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_APP_NOT_ACTIVE"] = 18] = "VALIDATION_ERROR_CODES_APP_NOT_ACTIVE";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_FEATURE_NOT_ENABLED"] = 19] = "VALIDATION_ERROR_CODES_FEATURE_NOT_ENABLED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_APP_IS_SUSPENDED"] = 20] = "VALIDATION_ERROR_CODES_APP_IS_SUSPENDED";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_PACKAGE_NOT_FOUND"] = 21] = "VALIDATION_ERROR_CODES_PACKAGE_NOT_FOUND";
  ValidationErrorCodes[ValidationErrorCodes["VALIDATION_ERROR_CODES_PARTNER_NOT_OWNER_OF_PACKAGE"] = 22] = "VALIDATION_ERROR_CODES_PARTNER_NOT_OWNER_OF_PACKAGE";
  return ValidationErrorCodes;
}(ValidationErrorCodes || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Frequency = /*#__PURE__*/function (Frequency) {
  Frequency[Frequency["FREQUENCY_INVALID"] = 0] = "FREQUENCY_INVALID";
  Frequency[Frequency["FREQUENCY_MONTHLY"] = 1] = "FREQUENCY_MONTHLY";
  Frequency[Frequency["FREQUENCY_YEARLY"] = 2] = "FREQUENCY_YEARLY";
  Frequency[Frequency["FREQUENCY_ONE_TIME"] = 3] = "FREQUENCY_ONE_TIME";
  return Frequency;
}(Frequency || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Consumer = /*#__PURE__*/function (Consumer) {
  Consumer[Consumer["CONSUMER_UNSET"] = 0] = "CONSUMER_UNSET";
  Consumer[Consumer["CONSUMER_WHOLESALE"] = 1] = "CONSUMER_WHOLESALE";
  Consumer[Consumer["CONSUMER_RETAIL"] = 2] = "CONSUMER_RETAIL";
  return Consumer;
}(Consumer || {});
var OrderItemStatus = /*#__PURE__*/function (OrderItemStatus) {
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_INVALID"] = 0] = "ORDER_ITEM_STATUS_INVALID";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_CREATED"] = 1] = "ORDER_ITEM_STATUS_CREATED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_VALIDATION_FAILED"] = 2] = "ORDER_ITEM_STATUS_VALIDATION_FAILED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_CHARGED"] = 3] = "ORDER_ITEM_STATUS_CHARGED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_CHARGE_SUCCESSFUL"] = 4] = "ORDER_ITEM_STATUS_CHARGE_SUCCESSFUL";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_CHARGE_FAILED"] = 5] = "ORDER_ITEM_STATUS_CHARGE_FAILED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_PENDING_ACTIVATION"] = 6] = "ORDER_ITEM_STATUS_PENDING_ACTIVATION";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_ACTIVATION_FAILED"] = 7] = "ORDER_ITEM_STATUS_ACTIVATION_FAILED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_ACTIVATION_SUCCESSFUL"] = 8] = "ORDER_ITEM_STATUS_ACTIVATION_SUCCESSFUL";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_CANCELED"] = 9] = "ORDER_ITEM_STATUS_CANCELED";
  OrderItemStatus[OrderItemStatus["ORDER_ITEM_STATUS_WAITING_FOR_CONSUMER_INFORMATION"] = 10] = "ORDER_ITEM_STATUS_WAITING_FOR_CONSUMER_INFORMATION";
  return OrderItemStatus;
}(OrderItemStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var OrderStatus = /*#__PURE__*/function (OrderStatus) {
  OrderStatus[OrderStatus["ORDER_STATUS_UNKNOWN"] = 0] = "ORDER_STATUS_UNKNOWN";
  OrderStatus[OrderStatus["ORDER_STATUS_CREATED"] = 1] = "ORDER_STATUS_CREATED";
  OrderStatus[OrderStatus["ORDER_STATUS_PROCESSING"] = 2] = "ORDER_STATUS_PROCESSING";
  OrderStatus[OrderStatus["ORDER_STATUS_CHARGED"] = 3] = "ORDER_STATUS_CHARGED";
  return OrderStatus;
}(OrderStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BillingFrequency = /*#__PURE__*/function (BillingFrequency) {
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_INVALID"] = 0] = "BILLING_FREQUENCY_INVALID";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_MONTHLY"] = 1] = "BILLING_FREQUENCY_MONTHLY";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_YEARLY"] = 2] = "BILLING_FREQUENCY_YEARLY";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_ONE_TIME"] = 3] = "BILLING_FREQUENCY_ONE_TIME";
  return BillingFrequency;
}(BillingFrequency || {});
var ChangeSpendRequestStatus = /*#__PURE__*/function (ChangeSpendRequestStatus) {
  ChangeSpendRequestStatus[ChangeSpendRequestStatus["CHANGE_SPEND_REQUEST_STATUS_INVALID"] = 0] = "CHANGE_SPEND_REQUEST_STATUS_INVALID";
  ChangeSpendRequestStatus[ChangeSpendRequestStatus["CHANGE_SPEND_REQUEST_STATUS_CREATED"] = 1] = "CHANGE_SPEND_REQUEST_STATUS_CREATED";
  ChangeSpendRequestStatus[ChangeSpendRequestStatus["CHANGE_SPEND_REQUEST_STATUS_APPROVED"] = 2] = "CHANGE_SPEND_REQUEST_STATUS_APPROVED";
  ChangeSpendRequestStatus[ChangeSpendRequestStatus["CHANGE_SPEND_REQUEST_STATUS_REJECTED"] = 3] = "CHANGE_SPEND_REQUEST_STATUS_REJECTED";
  ChangeSpendRequestStatus[ChangeSpendRequestStatus["CHANGE_SPEND_REQUEST_STATUS_OVERRIDDEN"] = 4] = "CHANGE_SPEND_REQUEST_STATUS_OVERRIDDEN";
  return ChangeSpendRequestStatus;
}(ChangeSpendRequestStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FailureReason = /*#__PURE__*/function (FailureReason) {
  FailureReason[FailureReason["FAILURE_REASON_UNKNOWN_ERROR"] = 0] = "FAILURE_REASON_UNKNOWN_ERROR";
  FailureReason[FailureReason["FAILURE_REASON_VALIDATION_ERROR"] = 1] = "FAILURE_REASON_VALIDATION_ERROR";
  FailureReason[FailureReason["FAILURE_REASON_CHARGE_ERROR"] = 2] = "FAILURE_REASON_CHARGE_ERROR";
  FailureReason[FailureReason["FAILURE_REASON_VENDOR_REJECTED_ERROR"] = 3] = "FAILURE_REASON_VENDOR_REJECTED_ERROR";
  FailureReason[FailureReason["FAILURE_REASON_ACTIVATION_ERROR"] = 4] = "FAILURE_REASON_ACTIVATION_ERROR";
  return FailureReason;
}(FailureReason || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["FIELD_TYPE_NOT_SPECIFIED"] = 0] = "FIELD_TYPE_NOT_SPECIFIED";
  FieldType[FieldType["FIELD_TYPE_TEXT"] = 1] = "FIELD_TYPE_TEXT";
  FieldType[FieldType["FIELD_TYPE_TEXT_AREA"] = 2] = "FIELD_TYPE_TEXT_AREA";
  FieldType[FieldType["FIELD_TYPE_DROPDOWN"] = 3] = "FIELD_TYPE_DROPDOWN";
  FieldType[FieldType["FIELD_TYPE_CHECKBOX"] = 4] = "FIELD_TYPE_CHECKBOX";
  FieldType[FieldType["FIELD_TYPE_FILE"] = 5] = "FIELD_TYPE_FILE";
  FieldType[FieldType["FIELD_TYPE_VBCUSER"] = 6] = "FIELD_TYPE_VBCUSER";
  return FieldType;
}(FieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FulfillmentOrderStatus = /*#__PURE__*/function (FulfillmentOrderStatus) {
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_UNSET"] = 0] = "FULFILLMENT_ORDER_STATUS_UNSET";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_DETAILS_NEEDED"] = 1] = "FULFILLMENT_ORDER_STATUS_DETAILS_NEEDED";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_IN_REVIEW"] = 2] = "FULFILLMENT_ORDER_STATUS_IN_REVIEW";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_IN_PROGRESS"] = 3] = "FULFILLMENT_ORDER_STATUS_IN_PROGRESS";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_COMPLETED"] = 4] = "FULFILLMENT_ORDER_STATUS_COMPLETED";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_CANCELLED"] = 5] = "FULFILLMENT_ORDER_STATUS_CANCELLED";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_ORDER_STATUS_ON_HOLD"] = 6] = "FULFILLMENT_ORDER_STATUS_ON_HOLD";
  return FulfillmentOrderStatus;
}(FulfillmentOrderStatus || {});
var PendingActivationStatus = /*#__PURE__*/function (PendingActivationStatus) {
  PendingActivationStatus[PendingActivationStatus["PENDING_ACTIVATION_STATUS_NOT_SPECIFIED"] = 0] = "PENDING_ACTIVATION_STATUS_NOT_SPECIFIED";
  PendingActivationStatus[PendingActivationStatus["PENDING_ACTIVATION_STATUS_PENDING"] = 1] = "PENDING_ACTIVATION_STATUS_PENDING";
  PendingActivationStatus[PendingActivationStatus["PENDING_ACTIVATION_STATUS_APPROVED"] = 2] = "PENDING_ACTIVATION_STATUS_APPROVED";
  PendingActivationStatus[PendingActivationStatus["PENDING_ACTIVATION_STATUS_REJECTED"] = 3] = "PENDING_ACTIVATION_STATUS_REJECTED";
  return PendingActivationStatus;
}(PendingActivationStatus || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_UNSET"] = 0] = "SORT_DIRECTION_UNSET";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var TimeField = /*#__PURE__*/function (TimeField) {
  TimeField[TimeField["TIME_FIELD_UNSET"] = 0] = "TIME_FIELD_UNSET";
  TimeField[TimeField["TIME_FIELD_CREATED"] = 1] = "TIME_FIELD_CREATED";
  TimeField[TimeField["TIME_FIELD_UPDATED"] = 2] = "TIME_FIELD_UPDATED";
  TimeField[TimeField["TIME_FIELD_DELETED"] = 3] = "TIME_FIELD_DELETED";
  return TimeField;
}(TimeField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Blame {
  static fromProto(proto) {
    let m = new Blame();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$8(BlameSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.sourceIdentifier !== 'undefined') {
      toReturn['sourceIdentifier'] = this.sourceIdentifier;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EditionChangeInformation {
  static fromProto(proto) {
    let m = new EditionChangeInformation();
    m = Object.assign(m, proto);
    if (proto.editionChangeReasons) {
      m.editionChangeReasons = Reasons.fromProto(proto.editionChangeReasons);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currentActivationId !== 'undefined') {
      toReturn['currentActivationId'] = this.currentActivationId;
    }
    if (typeof this.editionChangeReasons !== 'undefined' && this.editionChangeReasons !== null) {
      toReturn['editionChangeReasons'] = 'toApiJson' in this.editionChangeReasons ? this.editionChangeReasons.toApiJson() : this.editionChangeReasons;
    }
    return toReturn;
  }
}
class OrderItem {
  static fromProto(proto) {
    let m = new OrderItem();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$7(OrderItemStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.validationErrorCodes) {
      m.validationErrorCodes = proto.validationErrorCodes.map(v => enumStringToValue$7(ValidationErrorCodes, v));
    }
    if (proto.productActivationInformation) {
      m.productActivationInformation = ProductActivationInformation.fromProto(proto.productActivationInformation);
    }
    if (proto.editionChangeInformation) {
      m.editionChangeInformation = EditionChangeInformation.fromProto(proto.editionChangeInformation);
    }
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    if (proto.retailAmount) {
      m.retailAmount = parseInt(proto.retailAmount, 10);
    }
    if (proto.retailFrequency) {
      m.retailFrequency = enumStringToValue$7(Frequency, proto.retailFrequency);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$7(Consumer, proto.consumer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.validationErrorCodes !== 'undefined') {
      toReturn['validationErrorCodes'] = this.validationErrorCodes;
    }
    if (typeof this.productActivationInformation !== 'undefined' && this.productActivationInformation !== null) {
      toReturn['productActivationInformation'] = 'toApiJson' in this.productActivationInformation ? this.productActivationInformation.toApiJson() : this.productActivationInformation;
    }
    if (typeof this.editionChangeInformation !== 'undefined' && this.editionChangeInformation !== null) {
      toReturn['editionChangeInformation'] = 'toApiJson' in this.editionChangeInformation ? this.editionChangeInformation.toApiJson() : this.editionChangeInformation;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.chargeFailureCode !== 'undefined') {
      toReturn['chargeFailureCode'] = this.chargeFailureCode;
    }
    if (typeof this.packageInstanceId !== 'undefined') {
      toReturn['packageInstanceId'] = this.packageInstanceId;
    }
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    if (typeof this.retailAmount !== 'undefined') {
      toReturn['retailAmount'] = this.retailAmount;
    }
    if (typeof this.retailFrequency !== 'undefined') {
      toReturn['retailFrequency'] = this.retailFrequency;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    return toReturn;
  }
}
class ProductActivationInformation {
  static fromProto(proto) {
    let m = new ProductActivationInformation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Reasons {
  static fromProto(proto) {
    let m = new Reasons();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.choices !== 'undefined') {
      toReturn['choices'] = this.choices;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Order {
  static fromProto(proto) {
    let m = new Order();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.status) {
      m.status = enumStringToValue$6(OrderStatus, proto.status);
    }
    if (proto.orderSource) {
      m.orderSource = Blame.fromProto(proto.orderSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.orderSource !== 'undefined' && this.orderSource !== null) {
      toReturn['orderSource'] = 'toApiJson' in this.orderSource ? this.orderSource.toApiJson() : this.orderSource;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ChangeRequestEventExternalData {
  static fromProto(proto) {
    let m = new ChangeRequestEventExternalData();
    m = Object.assign(m, proto);
    if (proto.requestedSpendAmount) {
      m.requestedSpendAmount = parseInt(proto.requestedSpendAmount, 10);
    }
    if (proto.renewalDate) {
      m.renewalDate = new Date(proto.renewalDate);
    }
    if (proto.currentSubscriptionCost) {
      m.currentSubscriptionCost = parseInt(proto.currentSubscriptionCost, 10);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue$5(BillingFrequency, proto.billingFrequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.note !== 'undefined') {
      toReturn['note'] = this.note;
    }
    if (typeof this.requestedSpendAmount !== 'undefined') {
      toReturn['requestedSpendAmount'] = this.requestedSpendAmount;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.resellerName !== 'undefined') {
      toReturn['resellerName'] = this.resellerName;
    }
    if (typeof this.itemName !== 'undefined') {
      toReturn['itemName'] = this.itemName;
    }
    if (typeof this.renewalDate !== 'undefined' && this.renewalDate !== null) {
      toReturn['renewalDate'] = 'toApiJson' in this.renewalDate ? this.renewalDate.toApiJson() : this.renewalDate;
    }
    if (typeof this.currentSubscriptionCost !== 'undefined') {
      toReturn['currentSubscriptionCost'] = this.currentSubscriptionCost;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.resellerId !== 'undefined') {
      toReturn['resellerId'] = this.resellerId;
    }
    if (typeof this.resellerCurrency !== 'undefined') {
      toReturn['resellerCurrency'] = this.resellerCurrency;
    }
    return toReturn;
  }
}
class ChangeSpendRequest {
  static fromProto(proto) {
    let m = new ChangeSpendRequest();
    m = Object.assign(m, proto);
    if (proto.requestedSpendAmount) {
      m.requestedSpendAmount = parseInt(proto.requestedSpendAmount, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$5(ChangeSpendRequestStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.externalData) {
      m.externalData = ChangeSpendRequestExternalData.fromProto(proto.externalData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changeRequestId !== 'undefined') {
      toReturn['changeRequestId'] = this.changeRequestId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.requestedSpendAmount !== 'undefined') {
      toReturn['requestedSpendAmount'] = this.requestedSpendAmount;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.requesterNote !== 'undefined') {
      toReturn['requesterNote'] = this.requesterNote;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.requestingUser !== 'undefined') {
      toReturn['requestingUser'] = this.requestingUser;
    }
    if (typeof this.billingOrderId !== 'undefined') {
      toReturn['billingOrderId'] = this.billingOrderId;
    }
    if (typeof this.externalData !== 'undefined' && this.externalData !== null) {
      toReturn['externalData'] = 'toApiJson' in this.externalData ? this.externalData.toApiJson() : this.externalData;
    }
    return toReturn;
  }
}
class ChangeSpendRequestExternalData {
  static fromProto(proto) {
    let m = new ChangeSpendRequestExternalData();
    m = Object.assign(m, proto);
    if (proto.renewalDate) {
      m.renewalDate = new Date(proto.renewalDate);
    }
    if (proto.currentSubscriptionCost) {
      m.currentSubscriptionCost = parseInt(proto.currentSubscriptionCost, 10);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue$5(BillingFrequency, proto.billingFrequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.resellerName !== 'undefined') {
      toReturn['resellerName'] = this.resellerName;
    }
    if (typeof this.itemName !== 'undefined') {
      toReturn['itemName'] = this.itemName;
    }
    if (typeof this.renewalDate !== 'undefined' && this.renewalDate !== null) {
      toReturn['renewalDate'] = 'toApiJson' in this.renewalDate ? this.renewalDate.toApiJson() : this.renewalDate;
    }
    if (typeof this.currentSubscriptionCost !== 'undefined') {
      toReturn['currentSubscriptionCost'] = this.currentSubscriptionCost;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.resellerId !== 'undefined') {
      toReturn['resellerId'] = this.resellerId;
    }
    if (typeof this.resellerCurrency !== 'undefined') {
      toReturn['resellerCurrency'] = this.resellerCurrency;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivationFailureDetails {
  static fromProto(proto) {
    let m = new ActivationFailureDetails();
    m = Object.assign(m, proto);
    if (proto.failureReason) {
      m.failureReason = enumStringToValue$3(FailureReason, proto.failureReason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    if (typeof this.failureReason !== 'undefined') {
      toReturn['failureReason'] = this.failureReason;
    }
    if (typeof this.details !== 'undefined') {
      toReturn['details'] = this.details;
    }
    return toReturn;
  }
}
class CancelEditionChangeRequest {
  static fromProto(proto) {
    let m = new CancelEditionChangeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    return toReturn;
  }
}
class CancelOrderItemWaitingForConsumerInformationRequest {
  static fromProto(proto) {
    let m = new CancelOrderItemWaitingForConsumerInformationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestHistoryResponseChangeSpendRequestEvents {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestHistoryResponseChangeSpendRequestEvents();
    m = Object.assign(m, proto);
    if (proto.eventTime) {
      m.eventTime = new Date(proto.eventTime);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(ChangeSpendRequestStatus, proto.status);
    }
    if (proto.externalData) {
      m.externalData = ChangeRequestEventExternalData.fromProto(proto.externalData);
    }
    if (proto.effectiveDate) {
      m.effectiveDate = new Date(proto.effectiveDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.changeRequestId !== 'undefined') {
      toReturn['changeRequestId'] = this.changeRequestId;
    }
    if (typeof this.eventTime !== 'undefined' && this.eventTime !== null) {
      toReturn['eventTime'] = 'toApiJson' in this.eventTime ? this.eventTime.toApiJson() : this.eventTime;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.externalData !== 'undefined' && this.externalData !== null) {
      toReturn['externalData'] = 'toApiJson' in this.externalData ? this.externalData.toApiJson() : this.externalData;
    }
    if (typeof this.requestingUser !== 'undefined') {
      toReturn['requestingUser'] = this.requestingUser;
    }
    if (typeof this.resolvedBy !== 'undefined') {
      toReturn['resolvedBy'] = this.resolvedBy;
    }
    if (typeof this.effectiveDate !== 'undefined' && this.effectiveDate !== null) {
      toReturn['effectiveDate'] = 'toApiJson' in this.effectiveDate ? this.effectiveDate.toApiJson() : this.effectiveDate;
    }
    return toReturn;
  }
}
class ChangeSpendRequestRequest {
  static fromProto(proto) {
    let m = new ChangeSpendRequestRequest();
    m = Object.assign(m, proto);
    if (proto.requestedSpendAmount) {
      m.requestedSpendAmount = parseInt(proto.requestedSpendAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.requestedSpendAmount !== 'undefined') {
      toReturn['requestedSpendAmount'] = this.requestedSpendAmount;
    }
    if (typeof this.requesterNote !== 'undefined') {
      toReturn['requesterNote'] = this.requesterNote;
    }
    return toReturn;
  }
}
class CreateOrderRequest {
  static fromProto(proto) {
    let m = new CreateOrderRequest();
    m = Object.assign(m, proto);
    if (proto.orderItems) {
      m.orderItems = proto.orderItems.map(OrderItemParameters.fromProto);
    }
    if (proto.orderSource) {
      m.orderSource = Blame.fromProto(proto.orderSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.orderItems !== 'undefined' && this.orderItems !== null) {
      toReturn['orderItems'] = 'toApiJson' in this.orderItems ? this.orderItems.toApiJson() : this.orderItems;
    }
    if (typeof this.orderSource !== 'undefined' && this.orderSource !== null) {
      toReturn['orderSource'] = 'toApiJson' in this.orderSource ? this.orderSource.toApiJson() : this.orderSource;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class CreateOrderResponse {
  static fromProto(proto) {
    let m = new CreateOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class DismissFailedOrderItemRequest {
  static fromProto(proto) {
    let m = new DismissFailedOrderItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    return toReturn;
  }
}
class GetCurrentSpendRequest {
  static fromProto(proto) {
    let m = new GetCurrentSpendRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetCurrentSpendResponse {
  static fromProto(proto) {
    let m = new GetCurrentSpendResponse();
    m = Object.assign(m, proto);
    if (proto.spendAmount) {
      m.spendAmount = parseInt(proto.spendAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.spendAmount !== 'undefined') {
      toReturn['spendAmount'] = this.spendAmount;
    }
    return toReturn;
  }
}
class GetMultiActivationErrorsForOrderItemsRequest {
  static fromProto(proto) {
    let m = new GetMultiActivationErrorsForOrderItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItemIds !== 'undefined') {
      toReturn['orderItemIds'] = this.orderItemIds;
    }
    return toReturn;
  }
}
class GetMultiActivationErrorsForOrderItemsResponse {
  static fromProto(proto) {
    let m = new GetMultiActivationErrorsForOrderItemsResponse();
    m = Object.assign(m, proto);
    if (proto.failureDetails) {
      m.failureDetails = proto.failureDetails.map(ActivationFailureDetails.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.failureDetails !== 'undefined' && this.failureDetails !== null) {
      toReturn['failureDetails'] = 'toApiJson' in this.failureDetails ? this.failureDetails.toApiJson() : this.failureDetails;
    }
    return toReturn;
  }
}
class GetOrderByIdempotencyKeyRequest {
  static fromProto(proto) {
    let m = new GetOrderByIdempotencyKeyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class GetOrderByIdempotencyKeyResponse {
  static fromProto(proto) {
    let m = new GetOrderByIdempotencyKeyResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestHistoryRequest {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestHistoryRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListChangeSpendRequestHistoryRequestListChangeSpendRequestsHistoryFilterOptions.fromProto(proto.filterOptions);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestHistoryResponse {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestHistoryResponse();
    m = Object.assign(m, proto);
    if (proto.changeSpendRequestEvents) {
      m.changeSpendRequestEvents = proto.changeSpendRequestEvents.map(ListChangeSpendRequestHistoryResponseChangeSpendRequestEvents.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.changeSpendRequestEvents !== 'undefined' && this.changeSpendRequestEvents !== null) {
      toReturn['changeSpendRequestEvents'] = 'toApiJson' in this.changeSpendRequestEvents ? this.changeSpendRequestEvents.toApiJson() : this.changeSpendRequestEvents;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestsRequestListChangeSpendRequestsFilterOptions {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestsRequestListChangeSpendRequestsFilterOptions();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$3(ChangeSpendRequestStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestHistoryRequestListChangeSpendRequestsHistoryFilterOptions {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestHistoryRequestListChangeSpendRequestsHistoryFilterOptions();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$3(ChangeSpendRequestStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.changeRequestIds !== 'undefined') {
      toReturn['changeRequestIds'] = this.changeRequestIds;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestsRequest {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListChangeSpendRequestsRequestListChangeSpendRequestsFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListChangeSpendRequestsResponse {
  static fromProto(proto) {
    let m = new ListChangeSpendRequestsResponse();
    m = Object.assign(m, proto);
    if (proto.changeSpendRequests) {
      m.changeSpendRequests = proto.changeSpendRequests.map(ChangeSpendRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changeSpendRequests !== 'undefined' && this.changeSpendRequests !== null) {
      toReturn['changeSpendRequests'] = 'toApiJson' in this.changeSpendRequests ? this.changeSpendRequests.toApiJson() : this.changeSpendRequests;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListOrderItemsForBusinessRequest {
  static fromProto(proto) {
    let m = new ListOrderItemsForBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.filterByStatuses) {
      m.filterByStatuses = proto.filterByStatuses.map(v => enumStringToValue$3(OrderItemStatus, v));
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.filterByStatuses !== 'undefined') {
      toReturn['filterByStatuses'] = this.filterByStatuses;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListOrderItemsForOrderRequest {
  static fromProto(proto) {
    let m = new ListOrderItemsForOrderRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListOrderItemsResponse {
  static fromProto(proto) {
    let m = new ListOrderItemsResponse();
    m = Object.assign(m, proto);
    if (proto.orderItems) {
      m.orderItems = proto.orderItems.map(OrderItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItems !== 'undefined' && this.orderItems !== null) {
      toReturn['orderItems'] = 'toApiJson' in this.orderItems ? this.orderItems.toApiJson() : this.orderItems;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class OrderItemParameters {
  static fromProto(proto) {
    let m = new OrderItemParameters();
    m = Object.assign(m, proto);
    if (proto.productActivationInformation) {
      m.productActivationInformation = ProductActivationInformation.fromProto(proto.productActivationInformation);
    }
    if (proto.editionChangeInformation) {
      m.editionChangeInformation = EditionChangeInformation.fromProto(proto.editionChangeInformation);
    }
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    if (proto.retailAmount) {
      m.retailAmount = parseInt(proto.retailAmount, 10);
    }
    if (proto.retailFrequency) {
      m.retailFrequency = enumStringToValue$3(Frequency, proto.retailFrequency);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$3(Consumer, proto.consumer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.productActivationInformation !== 'undefined' && this.productActivationInformation !== null) {
      toReturn['productActivationInformation'] = 'toApiJson' in this.productActivationInformation ? this.productActivationInformation.toApiJson() : this.productActivationInformation;
    }
    if (typeof this.editionChangeInformation !== 'undefined' && this.editionChangeInformation !== null) {
      toReturn['editionChangeInformation'] = 'toApiJson' in this.editionChangeInformation ? this.editionChangeInformation.toApiJson() : this.editionChangeInformation;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    if (typeof this.packageInstanceId !== 'undefined') {
      toReturn['packageInstanceId'] = this.packageInstanceId;
    }
    if (typeof this.retailAmount !== 'undefined') {
      toReturn['retailAmount'] = this.retailAmount;
    }
    if (typeof this.retailFrequency !== 'undefined') {
      toReturn['retailFrequency'] = this.retailFrequency;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    return toReturn;
  }
}
class RecordOrderFormSubmissionAndActivateOrderItemRequest {
  static fromProto(proto) {
    let m = new RecordOrderFormSubmissionAndActivateOrderItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderItemId !== 'undefined') {
      toReturn['orderItemId'] = this.orderItemId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class ResolveChangeSpendRequestRequest {
  static fromProto(proto) {
    let m = new ResolveChangeSpendRequestRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$3(ChangeSpendRequestStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changeRequestId !== 'undefined') {
      toReturn['changeRequestId'] = this.changeRequestId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.statusUpdateNote !== 'undefined') {
      toReturn['statusUpdateNote'] = this.statusUpdateNote;
    }
    return toReturn;
  }
}
class ResolvePendingActivationRequest {
  static fromProto(proto) {
    let m = new ResolvePendingActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.activationDescriptor !== 'undefined') {
      toReturn['activationDescriptor'] = this.activationDescriptor;
    }
    if (typeof this.force !== 'undefined') {
      toReturn['force'] = this.force;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FulfillmentFormConfig {
  static fromProto(proto) {
    let m = new FulfillmentFormConfig();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = proto.orderForm.map(FulfillmentFormField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.activationMessage !== 'undefined') {
      toReturn['activationMessage'] = this.activationMessage;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    if (typeof this.usesPostBillingOrderForm !== 'undefined') {
      toReturn['usesPostBillingOrderForm'] = this.usesPostBillingOrderForm;
    }
    if (typeof this.footerText !== 'undefined') {
      toReturn['footerText'] = this.footerText;
    }
    return toReturn;
  }
}
class FulfillmentFormField {
  static fromProto(proto) {
    let m = new FulfillmentFormField();
    m = Object.assign(m, proto);
    if (proto.maxChoices) {
      m.maxChoices = parseInt(proto.maxChoices, 10);
    }
    if (proto.optionsWithLabels) {
      m.optionsWithLabels = proto.optionsWithLabels.map(FulfillmentFormFieldOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    if (typeof this.useWebhookValidator !== 'undefined') {
      toReturn['useWebhookValidator'] = this.useWebhookValidator;
    }
    if (typeof this.allowMultiples !== 'undefined') {
      toReturn['allowMultiples'] = this.allowMultiples;
    }
    if (typeof this.allowDuplicates !== 'undefined') {
      toReturn['allowDuplicates'] = this.allowDuplicates;
    }
    if (typeof this.maxChoices !== 'undefined') {
      toReturn['maxChoices'] = this.maxChoices;
    }
    if (typeof this.forOfficeUseOnly !== 'undefined') {
      toReturn['forOfficeUseOnly'] = this.forOfficeUseOnly;
    }
    if (typeof this.optionsWithLabels !== 'undefined' && this.optionsWithLabels !== null) {
      toReturn['optionsWithLabels'] = 'toApiJson' in this.optionsWithLabels ? this.optionsWithLabels.toApiJson() : this.optionsWithLabels;
    }
    if (typeof this.officeEditableOnly !== 'undefined') {
      toReturn['officeEditableOnly'] = this.officeEditableOnly;
    }
    return toReturn;
  }
}
class FulfillmentFormFieldOption {
  static fromProto(proto) {
    let m = new FulfillmentFormFieldOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CustomFields {
  static fromProto(proto) {
    let m = new CustomFields();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    return toReturn;
  }
}
class Field {
  static fromProto(proto) {
    let m = new Field();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$1(FieldType, proto.fieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    return toReturn;
  }
}
class FormAnswers {
  static fromProto(proto) {
    let m = new FormAnswers();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    return toReturn;
  }
}
class FulfillmentFormSubmission {
  static fromProto(proto) {
    let m = new FulfillmentFormSubmission();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.formAnswers) {
      m.formAnswers = proto.formAnswers.map(FormAnswers.fromProto);
    }
    if (proto.formConfig) {
      m.formConfig = FulfillmentFormConfig.fromProto(proto.formConfig);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    if (typeof this.formConfig !== 'undefined' && this.formConfig !== null) {
      toReturn['formConfig'] = 'toApiJson' in this.formConfig ? this.formConfig.toApiJson() : this.formConfig;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetLatestFulfillmentFormSubmissionRequest {
  static fromProto(proto) {
    let m = new GetLatestFulfillmentFormSubmissionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetLatestFulfillmentFormSubmissionResponse {
  static fromProto(proto) {
    let m = new GetLatestFulfillmentFormSubmissionResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentFormSubmission) {
      m.fulfillmentFormSubmission = FulfillmentFormSubmission.fromProto(proto.fulfillmentFormSubmission);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentFormSubmission !== 'undefined' && this.fulfillmentFormSubmission !== null) {
      toReturn['fulfillmentFormSubmission'] = 'toApiJson' in this.fulfillmentFormSubmission ? this.fulfillmentFormSubmission.toApiJson() : this.fulfillmentFormSubmission;
    }
    return toReturn;
  }
}
class UpsertFulfillmentFormSubmissionRequest {
  static fromProto(proto) {
    let m = new UpsertFulfillmentFormSubmissionRequest();
    m = Object.assign(m, proto);
    if (proto.formAnswers) {
      m.formAnswers = proto.formAnswers.map(FormAnswers.fromProto);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    if (typeof this.lastViewedTimestamp !== 'undefined') {
      toReturn['lastViewedTimestamp'] = this.lastViewedTimestamp;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class UpsertFulfillmentFormSubmissionResponse {
  static fromProto(proto) {
    let m = new UpsertFulfillmentFormSubmissionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PendingActivationInfoActivationStatusesEntry {
  static fromProto(proto) {
    let m = new PendingActivationInfoActivationStatusesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = enumStringToValue(PendingActivationStatus, proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class AppInfo {
  static fromProto(proto) {
    let m = new AppInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.appName !== 'undefined') {
      toReturn['appName'] = this.appName;
    }
    return toReturn;
  }
}
class BusinessInfo {
  static fromProto(proto) {
    let m = new BusinessInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.partnerLogoUrl !== 'undefined') {
      toReturn['partnerLogoUrl'] = this.partnerLogoUrl;
    }
    return toReturn;
  }
}
class SalesInfoCost {
  static fromProto(proto) {
    let m = new SalesInfoCost();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    return toReturn;
  }
}
class CreateFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new CreateFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.resellerPartnerId !== 'undefined') {
      toReturn['resellerPartnerId'] = this.resellerPartnerId;
    }
    if (typeof this.vendorPartnerId !== 'undefined') {
      toReturn['vendorPartnerId'] = this.vendorPartnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class CreateFulfillmentOrderResponse {
  static fromProto(proto) {
    let m = new CreateFulfillmentOrderResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrder) {
      m.fulfillmentOrder = FulfillmentOrder.fromProto(proto.fulfillmentOrder);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrder !== 'undefined' && this.fulfillmentOrder !== null) {
      toReturn['fulfillmentOrder'] = 'toApiJson' in this.fulfillmentOrder ? this.fulfillmentOrder.toApiJson() : this.fulfillmentOrder;
    }
    return toReturn;
  }
}
class DeleteFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new DeleteFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    return toReturn;
  }
}
class FulfillmentFormInfo {
  static fromProto(proto) {
    let m = new FulfillmentFormInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasForm !== 'undefined') {
      toReturn['hasForm'] = this.hasForm;
    }
    return toReturn;
  }
}
class FulfillmentOrder {
  static fromProto(proto) {
    let m = new FulfillmentOrder();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(FulfillmentOrderStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.businessInfo) {
      m.businessInfo = BusinessInfo.fromProto(proto.businessInfo);
    }
    if (proto.resellerPartnerInfo) {
      m.resellerPartnerInfo = ResellerPartnerInfo.fromProto(proto.resellerPartnerInfo);
    }
    if (proto.appInfo) {
      m.appInfo = AppInfo.fromProto(proto.appInfo);
    }
    if (proto.salesInfo) {
      m.salesInfo = SalesInfo.fromProto(proto.salesInfo);
    }
    if (proto.pendingActivationInfo) {
      m.pendingActivationInfo = PendingActivationInfo.fromProto(proto.pendingActivationInfo);
    }
    if (proto.fulfillmentFormInfo) {
      m.fulfillmentFormInfo = FulfillmentFormInfo.fromProto(proto.fulfillmentFormInfo);
    }
    if (proto.associatedProjects) {
      m.associatedProjects = proto.associatedProjects.map(FulfillmentOrderProjects.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.resellerPartnerId !== 'undefined') {
      toReturn['resellerPartnerId'] = this.resellerPartnerId;
    }
    if (typeof this.vendorPartnerId !== 'undefined') {
      toReturn['vendorPartnerId'] = this.vendorPartnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.businessInfo !== 'undefined' && this.businessInfo !== null) {
      toReturn['businessInfo'] = 'toApiJson' in this.businessInfo ? this.businessInfo.toApiJson() : this.businessInfo;
    }
    if (typeof this.resellerPartnerInfo !== 'undefined' && this.resellerPartnerInfo !== null) {
      toReturn['resellerPartnerInfo'] = 'toApiJson' in this.resellerPartnerInfo ? this.resellerPartnerInfo.toApiJson() : this.resellerPartnerInfo;
    }
    if (typeof this.appInfo !== 'undefined' && this.appInfo !== null) {
      toReturn['appInfo'] = 'toApiJson' in this.appInfo ? this.appInfo.toApiJson() : this.appInfo;
    }
    if (typeof this.salesInfo !== 'undefined' && this.salesInfo !== null) {
      toReturn['salesInfo'] = 'toApiJson' in this.salesInfo ? this.salesInfo.toApiJson() : this.salesInfo;
    }
    if (typeof this.pendingActivationInfo !== 'undefined' && this.pendingActivationInfo !== null) {
      toReturn['pendingActivationInfo'] = 'toApiJson' in this.pendingActivationInfo ? this.pendingActivationInfo.toApiJson() : this.pendingActivationInfo;
    }
    if (typeof this.pendingActivationIds !== 'undefined') {
      toReturn['pendingActivationIds'] = this.pendingActivationIds;
    }
    if (typeof this.fulfillmentFormInfo !== 'undefined' && this.fulfillmentFormInfo !== null) {
      toReturn['fulfillmentFormInfo'] = 'toApiJson' in this.fulfillmentFormInfo ? this.fulfillmentFormInfo.toApiJson() : this.fulfillmentFormInfo;
    }
    if (typeof this.associatedProjects !== 'undefined' && this.associatedProjects !== null) {
      toReturn['associatedProjects'] = 'toApiJson' in this.associatedProjects ? this.associatedProjects.toApiJson() : this.associatedProjects;
    }
    return toReturn;
  }
}
class FulfillmentOrderProjectionFilter {
  static fromProto(proto) {
    let m = new FulfillmentOrderProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeBusinessInfo !== 'undefined') {
      toReturn['includeBusinessInfo'] = this.includeBusinessInfo;
    }
    if (typeof this.includeResellerPartnerInfo !== 'undefined') {
      toReturn['includeResellerPartnerInfo'] = this.includeResellerPartnerInfo;
    }
    if (typeof this.includeAppInfo !== 'undefined') {
      toReturn['includeAppInfo'] = this.includeAppInfo;
    }
    if (typeof this.includeSalesInfo !== 'undefined') {
      toReturn['includeSalesInfo'] = this.includeSalesInfo;
    }
    if (typeof this.includePendingActivationInfo !== 'undefined') {
      toReturn['includePendingActivationInfo'] = this.includePendingActivationInfo;
    }
    if (typeof this.includeFulfillmentFormInfo !== 'undefined') {
      toReturn['includeFulfillmentFormInfo'] = this.includeFulfillmentFormInfo;
    }
    if (typeof this.includeProjects !== 'undefined') {
      toReturn['includeProjects'] = this.includeProjects;
    }
    return toReturn;
  }
}
class FulfillmentOrderProjects {
  static fromProto(proto) {
    let m = new FulfillmentOrderProjects();
    m = Object.assign(m, proto);
    if (proto.projectDueDate) {
      m.projectDueDate = new Date(proto.projectDueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.projectId !== 'undefined') {
      toReturn['projectId'] = this.projectId;
    }
    if (typeof this.projectName !== 'undefined') {
      toReturn['projectName'] = this.projectName;
    }
    if (typeof this.projectStatus !== 'undefined') {
      toReturn['projectStatus'] = this.projectStatus;
    }
    if (typeof this.projectAssigneeName !== 'undefined') {
      toReturn['projectAssigneeName'] = this.projectAssigneeName;
    }
    if (typeof this.projectDueDate !== 'undefined' && this.projectDueDate !== null) {
      toReturn['projectDueDate'] = 'toApiJson' in this.projectDueDate ? this.projectDueDate.toApiJson() : this.projectDueDate;
    }
    return toReturn;
  }
}
class FulfillmentOrders {
  static fromProto(proto) {
    let m = new FulfillmentOrders();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrders) {
      m.fulfillmentOrders = proto.fulfillmentOrders.map(FulfillmentOrder.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrders !== 'undefined' && this.fulfillmentOrders !== null) {
      toReturn['fulfillmentOrders'] = 'toApiJson' in this.fulfillmentOrders ? this.fulfillmentOrders.toApiJson() : this.fulfillmentOrders;
    }
    return toReturn;
  }
}
class GetMultiBySalesOrderIdsResponseFulfillmentOrdersMapEntry {
  static fromProto(proto) {
    let m = new GetMultiBySalesOrderIdsResponseFulfillmentOrdersMapEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = FulfillmentOrders.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GetFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new GetFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = FulfillmentOrderProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetFulfillmentOrderResponse {
  static fromProto(proto) {
    let m = new GetFulfillmentOrderResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrder) {
      m.fulfillmentOrder = FulfillmentOrder.fromProto(proto.fulfillmentOrder);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrder !== 'undefined' && this.fulfillmentOrder !== null) {
      toReturn['fulfillmentOrder'] = 'toApiJson' in this.fulfillmentOrder ? this.fulfillmentOrder.toApiJson() : this.fulfillmentOrder;
    }
    return toReturn;
  }
}
class GetFulfillmentOrdersForSalesOrderRequest {
  static fromProto(proto) {
    let m = new GetFulfillmentOrdersForSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = FulfillmentOrderProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetFulfillmentOrdersForSalesOrderResponse {
  static fromProto(proto) {
    let m = new GetFulfillmentOrdersForSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrders) {
      m.fulfillmentOrders = proto.fulfillmentOrders.map(FulfillmentOrder.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrders !== 'undefined' && this.fulfillmentOrders !== null) {
      toReturn['fulfillmentOrders'] = 'toApiJson' in this.fulfillmentOrders ? this.fulfillmentOrders.toApiJson() : this.fulfillmentOrders;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class GetMultiBySalesOrderIdsRequest {
  static fromProto(proto) {
    let m = new GetMultiBySalesOrderIdsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderIds !== 'undefined') {
      toReturn['salesOrderIds'] = this.salesOrderIds;
    }
    return toReturn;
  }
}
class GetMultiBySalesOrderIdsResponse {
  static fromProto(proto) {
    let m = new GetMultiBySalesOrderIdsResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrdersMap) {
      m.fulfillmentOrdersMap = Object.keys(proto.fulfillmentOrdersMap).reduce((obj, k) => {
        obj[k] = FulfillmentOrders.fromProto(proto.fulfillmentOrdersMap[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrdersMap !== 'undefined' && this.fulfillmentOrdersMap !== null) {
      toReturn['fulfillmentOrdersMap'] = 'toApiJson' in this.fulfillmentOrdersMap ? this.fulfillmentOrdersMap.toApiJson() : this.fulfillmentOrdersMap;
    }
    return toReturn;
  }
}
class SalesInfoOrderFormSubmission {
  static fromProto(proto) {
    let m = new SalesInfoOrderFormSubmission();
    m = Object.assign(m, proto);
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(Field.fromProto);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(Field.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class PendingActivationInfo {
  static fromProto(proto) {
    let m = new PendingActivationInfo();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = Object.keys(proto.activationStatuses).reduce((obj, k) => {
        obj[k] = enumStringToValue(PendingActivationStatus, proto.activationStatuses[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationStatuses !== 'undefined' && this.activationStatuses !== null) {
      toReturn['activationStatuses'] = 'toApiJson' in this.activationStatuses ? this.activationStatuses.toApiJson() : this.activationStatuses;
    }
    return toReturn;
  }
}
class ResellerPartnerInfo {
  static fromProto(proto) {
    let m = new ResellerPartnerInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class SalesInfo {
  static fromProto(proto) {
    let m = new SalesInfo();
    m = Object.assign(m, proto);
    if (proto.cost) {
      m.cost = SalesInfoCost.fromProto(proto.cost);
    }
    if (proto.orderForm) {
      m.orderForm = SalesInfoOrderFormSubmission.fromProto(proto.orderForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.submittedBy !== 'undefined') {
      toReturn['submittedBy'] = this.submittedBy;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    return toReturn;
  }
}
class SearchFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new SearchFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(FulfillmentOrderStatus, v));
    }
    if (proto.timeOptions) {
      m.timeOptions = SearchFulfillmentOrderTimeOptions.fromProto(proto.timeOptions);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue(SortDirection, proto.sortDirection);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = FulfillmentOrderProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.salesOrderIds !== 'undefined') {
      toReturn['salesOrderIds'] = this.salesOrderIds;
    }
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.resellerPartnerIds !== 'undefined') {
      toReturn['resellerPartnerIds'] = this.resellerPartnerIds;
    }
    if (typeof this.vendorPartnerIds !== 'undefined') {
      toReturn['vendorPartnerIds'] = this.vendorPartnerIds;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.timeOptions !== 'undefined' && this.timeOptions !== null) {
      toReturn['timeOptions'] = 'toApiJson' in this.timeOptions ? this.timeOptions.toApiJson() : this.timeOptions;
    }
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.activationIds !== 'undefined') {
      toReturn['activationIds'] = this.activationIds;
    }
    if (typeof this.excludeAppIds !== 'undefined') {
      toReturn['excludeAppIds'] = this.excludeAppIds;
    }
    if (typeof this.excludeResellerIds !== 'undefined') {
      toReturn['excludeResellerIds'] = this.excludeResellerIds;
    }
    if (typeof this.hasForm !== 'undefined') {
      toReturn['hasForm'] = this.hasForm;
    }
    if (typeof this.fulfillmentOrderIds !== 'undefined') {
      toReturn['fulfillmentOrderIds'] = this.fulfillmentOrderIds;
    }
    return toReturn;
  }
}
class SearchFulfillmentOrderResponse {
  static fromProto(proto) {
    let m = new SearchFulfillmentOrderResponse();
    m = Object.assign(m, proto);
    if (proto.fulfillmentOrders) {
      m.fulfillmentOrders = proto.fulfillmentOrders.map(FulfillmentOrder.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrders !== 'undefined' && this.fulfillmentOrders !== null) {
      toReturn['fulfillmentOrders'] = 'toApiJson' in this.fulfillmentOrders ? this.fulfillmentOrders.toApiJson() : this.fulfillmentOrders;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SearchFulfillmentOrderTimeOptions {
  static fromProto(proto) {
    let m = new SearchFulfillmentOrderTimeOptions();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.timeField) {
      m.timeField = enumStringToValue(TimeField, proto.timeField);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.timeField !== 'undefined') {
      toReturn['timeField'] = this.timeField;
    }
    return toReturn;
  }
}
class SendFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new SendFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.itemNames !== 'undefined') {
      toReturn['itemNames'] = this.itemNames;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class UpdateFulfillmentOrderRequest {
  static fromProto(proto) {
    let m = new UpdateFulfillmentOrderRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(FulfillmentOrderStatus, proto.status);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'order-fulfillment-api.vendasta-local.com',
  'test': '',
  'demo': 'order-fulfillment-api-demo.apigateway.co',
  'prod': 'order-fulfillment-api-prod.apigateway.co',
  'production': 'order-fulfillment-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let OrderFulfillmentApiService = /*#__PURE__*/(() => {
  class OrderFulfillmentApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createOrder(r) {
      const request = r.toApiJson ? r : new CreateOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/CreateOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateOrderResponse.fromProto(resp)));
    }
    listOrderItemsForBusiness(r) {
      const request = r.toApiJson ? r : new ListOrderItemsForBusinessRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ListOrderItemsForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOrderItemsResponse.fromProto(resp)));
    }
    getOrderByIdempotencyKey(r) {
      const request = r.toApiJson ? r : new GetOrderByIdempotencyKeyRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/GetOrderByIdempotencyKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOrderByIdempotencyKeyResponse.fromProto(resp)));
    }
    listOrderItemsForOrder(r) {
      const request = r.toApiJson ? r : new ListOrderItemsForOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ListOrderItemsForOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOrderItemsResponse.fromProto(resp)));
    }
    dismissFailedOrderItem(r) {
      const request = r.toApiJson ? r : new DismissFailedOrderItemRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/DismissFailedOrderItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resolvePendingActivation(r) {
      const request = r.toApiJson ? r : new ResolvePendingActivationRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ResolvePendingActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    cancelEditionChange(r) {
      const request = r.toApiJson ? r : new CancelEditionChangeRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/CancelEditionChange", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    cancelOrderItemWaitingForConsumerInformation(r) {
      const request = r.toApiJson ? r : new CancelOrderItemWaitingForConsumerInformationRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/CancelOrderItemWaitingForConsumerInformation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    recordOrderFormSubmissionAndActivateOrderItem(r) {
      const request = r.toApiJson ? r : new RecordOrderFormSubmissionAndActivateOrderItemRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/RecordOrderFormSubmissionAndActivateOrderItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiActivationErrorsForOrderItems(r) {
      const request = r.toApiJson ? r : new GetMultiActivationErrorsForOrderItemsRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/GetMultiActivationErrorsForOrderItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiActivationErrorsForOrderItemsResponse.fromProto(resp)));
    }
    requestSpendAmountChange(r) {
      const request = r.toApiJson ? r : new ChangeSpendRequestRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/RequestSpendAmountChange", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listChangeSpendRequests(r) {
      const request = r.toApiJson ? r : new ListChangeSpendRequestsRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ListChangeSpendRequests", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListChangeSpendRequestsResponse.fromProto(resp)));
    }
    resolveChangeSpendRequest(r) {
      const request = r.toApiJson ? r : new ResolveChangeSpendRequestRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ResolveChangeSpendRequest", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listChangeSpendRequestHistory(r) {
      const request = r.toApiJson ? r : new ListChangeSpendRequestHistoryRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/ListChangeSpendRequestHistory", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListChangeSpendRequestHistoryResponse.fromProto(resp)));
    }
    getCurrentSpend(r) {
      const request = r.toApiJson ? r : new GetCurrentSpendRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.OrderFulfillmentService/GetCurrentSpend", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCurrentSpendResponse.fromProto(resp)));
    }
  }
  OrderFulfillmentApiService.ɵfac = function OrderFulfillmentApiService_Factory(t) {
    return new (t || OrderFulfillmentApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  OrderFulfillmentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OrderFulfillmentApiService,
    factory: OrderFulfillmentApiService.ɵfac,
    providedIn: 'root'
  });
  return OrderFulfillmentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrderFulfillmentService = /*#__PURE__*/(() => {
  class OrderFulfillmentService {
    constructor(_api) {
      this._api = _api;
    }
    createOrder(partnerId, orderParams, orderSources) {
      return this._api.createOrder({
        partnerId,
        orderItems: orderParams,
        orderSource: orderSources
      }).pipe(map(resp => {
        return resp.orderId;
      }));
    }
    listOrderItemsForBusiness(businessId, cursor, pageSize, filterByStatuses, fieldMask) {
      return this._api.listOrderItemsForBusiness({
        businessId,
        filterByStatuses,
        fieldMask,
        cursor,
        pageSize
      });
    }
    getOrderByIdempotencyKey(idempotencyKey) {
      return this._api.getOrderByIdempotencyKey({
        idempotencyKey: idempotencyKey
      }).pipe(map(resp => {
        return resp.order;
      }));
    }
    listOrderItemsForOrder(orderId, cursor, pageSize) {
      return this._api.listOrderItemsForOrder({
        orderId,
        cursor,
        pageSize
      });
    }
    dismissFailedOrderItem(orderId, businessId, itemId, orderItemId) {
      return this._api.dismissFailedOrderItem({
        orderId,
        businessId,
        itemId,
        orderItemId
      });
    }
    cancelEditionChange(orderItemId) {
      return this._api.cancelEditionChange({
        orderItemId
      });
    }
    getMultiActivationErrorsForOrderItems(orderItemIds) {
      return this._api.getMultiActivationErrorsForOrderItems({
        orderItemIds: orderItemIds
      }).pipe(map(resp => {
        return resp.failureDetails;
      }));
    }
    changeSpendRequest(businessId, itemId, activationId, requestedSpendAmount, requesterNote) {
      return this._api.requestSpendAmountChange({
        businessId,
        itemId,
        activationId,
        requestedSpendAmount,
        requesterNote
      });
    }
    listChangeSpendRequests(pageSize, cursor, appIds, businessIds, requestsStatuses) {
      return this._api.listChangeSpendRequests({
        pageSize: pageSize,
        cursor: cursor,
        filterOptions: {
          itemIds: appIds,
          businessIds: businessIds,
          statuses: requestsStatuses
        }
      });
    }
    listChangeSpendRequestHistory(pageSize, cursor, appIds, businessIds, changeRequestIds, requestsStatuses, fieldMasks) {
      return this._api.listChangeSpendRequestHistory({
        pageSize: pageSize,
        cursor: cursor,
        filterOptions: {
          itemIds: appIds,
          businessIds: businessIds,
          changeRequestIds: changeRequestIds,
          statuses: requestsStatuses
        },
        fieldMask: {
          paths: fieldMasks
        }
      });
    }
    resolveChangeSpendRequest(changeRequestId, businessId, appOrAddonId, activationId, status, statusUpdateNote) {
      return this._api.resolveChangeSpendRequest({
        changeRequestId: changeRequestId,
        itemId: appOrAddonId,
        activationId: activationId,
        status: status,
        statusUpdateNote: statusUpdateNote,
        businessId: businessId
      });
    }
    GetCurrentSpend(partnerId, businessId, appOrAddonId, activationId) {
      return this._api.getCurrentSpend({
        partnerId: partnerId,
        businessId: businessId,
        itemId: appOrAddonId,
        activationId: activationId
      });
    }
  }
  OrderFulfillmentService.ɵfac = function OrderFulfillmentService_Factory(t) {
    return new (t || OrderFulfillmentService)(i0.ɵɵinject(OrderFulfillmentApiService));
  };
  OrderFulfillmentService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OrderFulfillmentService,
    factory: OrderFulfillmentService.ɵfac,
    providedIn: 'root'
  });
  return OrderFulfillmentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FulfillmentFormSubmissionApiService = /*#__PURE__*/(() => {
  class FulfillmentFormSubmissionApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getLatestFulfillmentFormSubmission(r) {
      const request = r.toApiJson ? r : new GetLatestFulfillmentFormSubmissionRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentFormSubmissionService/GetLatestFulfillmentFormSubmission", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLatestFulfillmentFormSubmissionResponse.fromProto(resp)));
    }
    upsertFulfillmentFormSubmission(r) {
      const request = r.toApiJson ? r : new UpsertFulfillmentFormSubmissionRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentFormSubmissionService/UpsertFulfillmentFormSubmission", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertFulfillmentFormSubmissionResponse.fromProto(resp)));
    }
  }
  FulfillmentFormSubmissionApiService.ɵfac = function FulfillmentFormSubmissionApiService_Factory(t) {
    return new (t || FulfillmentFormSubmissionApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FulfillmentFormSubmissionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FulfillmentFormSubmissionApiService,
    factory: FulfillmentFormSubmissionApiService.ɵfac,
    providedIn: 'root'
  });
  return FulfillmentFormSubmissionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FulfillmentOrderApiService = /*#__PURE__*/(() => {
  class FulfillmentOrderApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new CreateFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/CreateFulfillmentOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateFulfillmentOrderResponse.fromProto(resp)));
    }
    getFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new GetFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/GetFulfillmentOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFulfillmentOrderResponse.fromProto(resp)));
    }
    updateFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new UpdateFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/UpdateFulfillmentOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new DeleteFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/DeleteFulfillmentOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new SearchFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/SearchFulfillmentOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchFulfillmentOrderResponse.fromProto(resp)));
    }
    getFulfillmentOrdersForSalesOrder(r) {
      const request = r.toApiJson ? r : new GetFulfillmentOrdersForSalesOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/GetFulfillmentOrdersForSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFulfillmentOrdersForSalesOrderResponse.fromProto(resp)));
    }
    getMultiBySalesOrderIds(r) {
      const request = r.toApiJson ? r : new GetMultiBySalesOrderIdsRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/GetMultiBySalesOrderIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBySalesOrderIdsResponse.fromProto(resp)));
    }
    sendFulfillmentOrder(r) {
      const request = r.toApiJson ? r : new SendFulfillmentOrderRequest(r);
      return this.http.post(this._host + "/orderfulfillment.v1.FulfillmentOrderService/SendFulfillmentOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FulfillmentOrderApiService.ɵfac = function FulfillmentOrderApiService_Factory(t) {
    return new (t || FulfillmentOrderApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FulfillmentOrderApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FulfillmentOrderApiService,
    factory: FulfillmentOrderApiService.ɵfac,
    providedIn: 'root'
  });
  return FulfillmentOrderApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { ActivationFailureDetails, AppInfo, BillingFrequency, Blame, BlameSource, BusinessInfo, CancelEditionChangeRequest, CancelOrderItemWaitingForConsumerInformationRequest, ChangeRequestEventExternalData, ChangeSpendRequest, ChangeSpendRequestExternalData, ChangeSpendRequestRequest, ChangeSpendRequestStatus, Consumer, CreateFulfillmentOrderRequest, CreateFulfillmentOrderResponse, CreateOrderRequest, CreateOrderResponse, CustomFields, DeleteFulfillmentOrderRequest, DismissFailedOrderItemRequest, EditionChangeInformation, FailureReason, Field, FieldMask, FieldType, FormAnswers, Frequency, FulfillmentFormConfig, FulfillmentFormField, FulfillmentFormFieldOption, FulfillmentFormInfo, FulfillmentFormSubmission, FulfillmentFormSubmissionApiService, FulfillmentOrder, FulfillmentOrderApiService, FulfillmentOrderProjectionFilter, FulfillmentOrderProjects, FulfillmentOrderStatus, FulfillmentOrders, GetCurrentSpendRequest, GetCurrentSpendResponse, GetFulfillmentOrderRequest, GetFulfillmentOrderResponse, GetFulfillmentOrdersForSalesOrderRequest, GetFulfillmentOrdersForSalesOrderResponse, GetLatestFulfillmentFormSubmissionRequest, GetLatestFulfillmentFormSubmissionResponse, GetMultiActivationErrorsForOrderItemsRequest, GetMultiActivationErrorsForOrderItemsResponse, GetMultiBySalesOrderIdsRequest, GetMultiBySalesOrderIdsResponse, GetMultiBySalesOrderIdsResponseFulfillmentOrdersMapEntry, GetOrderByIdempotencyKeyRequest, GetOrderByIdempotencyKeyResponse, HostService, ListChangeSpendRequestHistoryRequest, ListChangeSpendRequestHistoryRequestListChangeSpendRequestsHistoryFilterOptions, ListChangeSpendRequestHistoryResponse, ListChangeSpendRequestHistoryResponseChangeSpendRequestEvents, ListChangeSpendRequestsRequest, ListChangeSpendRequestsRequestListChangeSpendRequestsFilterOptions, ListChangeSpendRequestsResponse, ListOrderItemsForBusinessRequest, ListOrderItemsForOrderRequest, ListOrderItemsResponse, Order, OrderFulfillmentApiService, OrderFulfillmentService, OrderItem, OrderItemParameters, OrderItemStatus, OrderStatus, PendingActivationInfo, PendingActivationInfoActivationStatusesEntry, PendingActivationStatus, ProductActivationInformation, Reasons, RecordOrderFormSubmissionAndActivateOrderItemRequest, ResellerPartnerInfo, ResolveChangeSpendRequestRequest, ResolvePendingActivationRequest, SalesInfo, SalesInfoCost, SalesInfoOrderFormSubmission, SearchFulfillmentOrderRequest, SearchFulfillmentOrderResponse, SearchFulfillmentOrderTimeOptions, SendFulfillmentOrderRequest, SortDirection, TimeField, UpdateFulfillmentOrderRequest, UpsertFulfillmentFormSubmissionRequest, UpsertFulfillmentFormSubmissionResponse, ValidationErrorCodes };
